<div class="edp-select-searchable mb-4" role="group" ngbDropdown [autoClose]="'outside'" (openChange)="onDropdownChanged($event)">
    <div class="edp-selected" ngbDropdownToggle>
        <input
            type="text"
            class="form-control dropdown-input"
            [ngClass]="{ 'dropdown-input-selected': !!selected }"
            [formControl]="formSearch"
            placeholder="{{ placeholder | translate }}"
            (keyup.enter)="selectFirstOption()"
        />
        <span class="select-icon">
            <i class="icon icon-edponline-Bop-073" [ngClass]="{ 'icon-selected': !!selected }" aria-hidden="true"></i>
        </span>
    </div>
    <ul class="select-list-searchable" ngbDropdownMenu [ngClass]="{ 'half-height': halfHeight }">
        <li
            *ngFor="let option of _optionList | async"
            ngbDropdownItem
            class="select-item"
            [ngClass]="{ searching: !!formSearch.value }"
            (click)="onChangeOption(option); closeDropdown()"
        >
            <div class="select-item-title" [innerHTML]="option.text | edpBoldSearch: formSearch.value"></div>
        </li>
        <li *ngIf="(_optionList | async).length === 0" ngbDropdownItem class="select-item unclickable">
            <div class="select-item-title">(sem correspondência)</div>
        </li>
    </ul>
</div>
